// BibliotecaPage.js
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { database, ref, push, onValue, set } from "../firebase";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";

const documentos = [
  { id: 1, titulo: "Agro-Pecuária 12ºclasse", tipo: "Manuais", driveId: "1FhKwV7PL_FVddBQMqNhBam7OQ1_8Zcy5", icone: "🌾" },
  { id: 2, titulo: "Biologia 11ºclasse", tipo: "Manuais", driveId: "1sJjy259Z-h2Vi9-YpsE3Qhk2onFCDCtj", icone: "🧬" },
  { id: 3, titulo: "Desenho e Geometria Descritiva 12ºclasse", tipo: "Manuais", driveId: "1rnAsuGnXM2fwaJlOIyAdcbJntU8xWwMx", icone: "📐" },
  { id: 4, titulo: "Inglês 11ºclasse", tipo: "Manuais", driveId: "198tfTb4tz1Xw3gwIeHb905n89fI84LP2", icone: "🇬🇧" },
  { id: 5, titulo: "Filosofia 12ºclasse", tipo: "Manuais", driveId: "1SgQq3KvQtmcvnNUgtj8j6RYaK1iCDEra", icone: "🤔" },
  { id: 6, titulo: "Filosofia 11ºclasse", tipo: "Manuais", driveId: "1ueNpCBtkOVbAzr_ZwDHDM93GWM7DaKl6", icone: "🤔" },
  { id: 7, titulo: "Matemática 10ºclasse", tipo: "Manuais", driveId: "1D30U0qpNiZjeRx6BIrbYnXnMFtpaf6L6", icone: "➕" },
  { id: 8, titulo: "Matemática 12ºclasse", tipo: "Manuais", driveId: "1ueNpCBtkOVbAzr_ZwDHDM93GWM7DaKl6", icone: "➕" },
  { id: 9, titulo: "Matemática 12ºclasse (Plural editores)", tipo: "Manuais", driveId: "1c1rwhuiWntBO8rdYrFLnLvCis_IEmk4v", icone: "➕" },
  { id: 10, titulo: "Português 12ºclasse (LongMan)", tipo: "Manuais", driveId: "1lmNIm0BlbcyId-iocYdP6i_HesJQDQzq", icone: "pt" },
  { id: 11, titulo: "Química 12ºclasse", tipo: "Manuais", driveId: "14nv8oUHeWtcA3BzdrpWhe3RFZtflAxGS", icone: "⚗️" },
  { id: 12, titulo: "Química 11ºclasse", tipo: "Manuais", driveId: "1tmhBmrpyXcoVCOyQU_UNBOwAl_664rzt", icone: "⚗️" },
  { id: 13, titulo: "Tecnologias de Informação e Comunicação (TICs) 11ºclasse", tipo: "Manuais", driveId: "1hHu1qxbmfUr0AXRxEUBG_P-CCQZ05tgw", icone: "🖥️" },
  { id: 14, titulo: "Desenho e Geometria 12ºclasse", tipo: "Manuais", driveId: "1rnAsuGnXM2fwaJlOIyAdcbJntU8xWwMx", icone: "📐" },
  { id: 15, titulo: "História 12ºclasse", tipo: "Manuais", driveId: "1-RreJKXToPgreXqrHBlFVMhcnL2i3ycU", icone: "📚" },
  { id: 16, titulo: "Inglês 12ºclasse", tipo: "Manuais", driveId: "198tfTb4tz1Xw3gwIeHb905n89fI84LP2", icone: "🇬🇧" },
  { id: 18, titulo: "A sutil arte de ligar o f*da-se - Mark Manson", tipo: "Livros", driveId: "1K0c8Vhy_MrzREfccro7zZi1sSKoSutzi", icone: "💭" },
  { id: 19, titulo: "O Poder do Hábito - Charles Duhigg", tipo: "Livros", driveId: "1K7jqYVD8J_2mciPQIbyzLUAxvEiW0WtZ", icone: "⚡" },
  { id: 20, titulo: "INFECTO Vol. 2 – AIDS e Síndrome da Imunodeficiência Adquirida", tipo: "Livros", driveId: "1KJ9GmOmTHx_4bfE_gYvYfiT5EtKCh5v7", icone: "🔬" },
  { id: 21, titulo: "A Psicologia do Dinheiro - Dan Ariely", tipo: "Livros", driveId: "1UVQf5XSOEkJ2syavaAIqFLn7okn-h7d_", icone: "💰" },
  { id: 22, titulo: "Exame/UP/Física/2018", tipo: "Exames", driveId: "10Ywycfvqimx97P_gFNiteX14GsJEP0TO", icone: "📝" },
  { id: 23, titulo: "Exame/UEM/Português/2013", tipo: "Exames", driveId: "11J3U4tKXgqvRr4mboLVQMeGdZU_hgYb_", icone: "📝" },
  { id: 24, titulo: "Exame/UEM/Português/2017", tipo: "Exames", driveId: "11PTjNK7qZok-tHqiKbj-CGW6UNPO7HJq", icone: "📝" },
  { id: 25, titulo: "Exame/UP/Física/2016", tipo: "Exames", driveId: "10v-ZFX5Ry9wBGOKGbI2MWKRNucIYWBfD", icone: "📝" },
  { id: 26, titulo: "Exame/UP/Física/2014", tipo: "Exames", driveId: "11D5k2O4ttsf7fpEId8VL2xO9zh35qdJR", icone: "📝" },
  { id: 27, titulo: "Exame/UP/Física/2019", tipo: "Exames", driveId: "11ZXby0_F69B3Jn4TbqHuOd6kgOQQYKVt", icone: "📝" },
  { id: 28, titulo: "Exame/UP/Física/2018", tipo: "Exames", driveId: "OUTRO_ID_AQUI", icone: "📝" },
  { id: 29, titulo: "Exame/UP-UniPungue-Unilicungo-Unirovuma/Física/2022", tipo: "Exames", driveId: "11YAZKhmwov3TwkvzFetK-cXrBbvFMVoT", icone: "📝" },
  { id: 30, titulo: "Relacionamento é para gente disposta - Geffo Pinheiro", tipo: "Livros", driveId: "1KApMbBLt1QD_SoctP7O02QE492om4e73", icone: "💕" },
  { id: 31, titulo: "A ideia de áfrica - V.Y. Mudimbe", tipo: "Livros", driveId: "1Qnr-6T-wArEF8lerqhgrfUEFPrIbYhG4", icone: "🌍" },
  { id: 32, titulo: "Ecologia Humana & Pandemias - Consequências da COVID-19 para o nosso futuro - Juracy Marques & Artur Dias-Lima", tipo: "Livros", driveId: "1jRqNg4hv40EoXvbDdUxq0Uq5ISAZmRdM", icone: "🌱" },
  { id: 33, titulo: "Ecologia, Evolução e Diversidade - Patrícia Michele da Luz", tipo: "Livros", driveId: "1jPMGAG2FHBgKpJBrrC_M2rOMjwCmWsOP", icone: "🌿" },
  { id: 34, titulo: "Vocabulário Essencial do Francês - Adir Ferreira", tipo: "Livros", driveId: "1n_OSVmlf2nmDxFHjK9Aij0gK1eBeD_zQ", icone: "🇫🇷" },
  { id: 35, titulo: "Inglês Aplicado", tipo: "Manuais", driveId: "1S7zwyqA1q9ixeIcyFXXs9bsmK1W4xZ6I", icone: "🇬🇧" },
  { id: 36, titulo: "Exame/ISCISA/Biologia/2017", tipo: "Exames", driveId: "1VB8GO7zRQ15sXW5GX4LP-8yqdVbTWihq", icone: "📝" },
  { id: 37, titulo: "Exame/ISCISA/Biologia/2018", tipo: "Exames", driveId: "11IjT0o4-YcdTmY57520MdaPMzh81oqDl", icone: "📝" },
  { id: 38, titulo: "Exame/ISCISA/Biologia/2017", tipo: "Exames", driveId: "1AGThIc3Ar7rD4RVLdvX_4O5v4xGUKzAu", icone: "📝" },
  { id: 39, titulo: "Exame/ISArC/Cultura Geral/2014", tipo: "Exames", driveId: "1uT6dywRnnfR7hl60dycUIwb0dAic3FQa", icone: "📝" },
  { id: 40, titulo: "Exame/ISArC/Cultura Geral/2016", tipo: "Exames", driveId: "1KS7cBPaaGCJ5v_5zR1BsZ5Euk0BkSp9i", icone: "📝" },
  { id: 41, titulo: "Exame/ISArC/Cultura Geral/2017", tipo: "Exames", driveId: "1p8Mrh7nh78Sdoy5jJdQWRCYQJU-z2wzm", icone: "📝" },
  { id: 42, titulo: "Exame/Academia-Militar-Samora-Machel/Desenho/2014", tipo: "Exames", driveId: "1Y3fmfLdloPK2S6wHoB3Bmxs8YRH5K4NV", icone: "📝" },
  { id: 43, titulo: "Exame/Academia-Militar-Samora-Machel/Desenho/2016", tipo: "Exames", driveId: "1Recgam4vPi4rbdCNcwSW1NDy-xwiQYkZ", icone: "📝" },
  { id: 44, titulo: "Exame/Academia-Militar-Samora-Machel/Desenho/2018", tipo: "Exames", driveId: "1bUA1qtPEmvbp7zjSyryFmjurpqnTcy3q", icone: "📝" },
  { id: 45, titulo: "Exame/Desenho/2005", tipo: "Exames", driveId: "18L5J9H8_ObWroqBYSwT6C-ebC8wIBCqR", icone: "📝" },
  { id: 46, titulo: "Exame/IFP/Português/2021", tipo: "Exames", driveId: "1XWduvTbYeJ6G1Uftwu_dyWtkS5fwx1NQ", icone: "📝" },
  { id: 47, titulo: "Exame/UEM/Francês/2013", tipo: "Exames", driveId: "1fn33rAwpI9a3ZIlR23VsUYRIwt2LMmBX", icone: "📝" },
  { id: 48, titulo: "Exame/UEM/Francês/2013", tipo: "Exames", driveId: "1bUA1qtPEmvbp7zjSyryFmjurpqnTcy3q", icone: "📝" },
  { id: 49, titulo: "Exame/UEM/Francês/2016", tipo: "Exames", driveId: "1nVX0Q_yFZB_gOhJn2nPvlvWRtSyJF5az", icone: "📝" },
  { id: 50, titulo: "Exame/UEM/Francês/2017", tipo: "Exames", driveId: "12G68q_Yg_6T448X2RRwScOnemx6U7_yd", icone: "📝" },
  { id: 51, titulo: "Exame/UEM/Geografia/2014", tipo: "Exames", driveId: "1MMdtZbWvESzqfQRxOJg4LYvOVKHgg_eV", icone: "📝" },
  { id: 52, titulo: "Exame/ISRI/Geografia/2017", tipo: "Exames", driveId: "12J1mBa9ZZYGsqLAY2_k-PiAXDNToL8jb", icone: "📝" },
  { id: 53, titulo: "Exame/Academia-Militar-Samora-Machel/Matemática/2014", tipo: "Exames", driveId: "117GqRoFA6vgGgM_b3rZrBb55dt6ZG_cH", icone: "📝" },
  { id: 54, titulo: "Exame/Academia-Militar-Samora-Machel/Matemática/2016", tipo: "Exames", driveId: "18qWsAPKA9b9zqJWG7Sv0BizXyoDl1LS7", icone: "📝" },
  { id: 55, titulo: "Exame/ACIPOL/Matemática/2019", tipo: "Exames", driveId: "1MUf223P4n-ENiPpz0gkwDN-_6mFwcVbs", icone: "📝" },
  { id: 56, titulo: "Exame/ACIPOL/Matemática/2017", tipo: "Exames", driveId: "1HiJREXMBQOGy56H4egzj4WpWQBdz3YsE", icone: "📝" },
  { id: 57, titulo: "Exame/UEM/Biologia/2016", tipo: "Exames", driveId: "1STf_ZHzGLXUqlOelVIswVkTrqOhB4gBj", icone: "📝" },

];

const categorias = [
  { nome: "Manuais", icone: "📚", cor: "#4CAF50" },
  { nome: "Exames", icone: "📝", cor: "#2196F3" },
  { nome: "Livros", icone: "📖", cor: "#FF9800" }
];

const emojis = ["😀", "🎓", "📚", "🔥", "💬", "❤️", "👏", "👍", "🎉", "💡", "🌟", "✨"];

export default function BibliotecaPage() {
  const [categoriaAtiva, setCategoriaAtiva] = useState("Manuais");
  const [docSelecionado, setDocSelecionado] = useState(null);
  const [mensagens, setMensagens] = useState([]);
  const [novaMensagem, setNovaMensagem] = useState("");
  const [usuario, setUsuario] = useState(null);
  const [mostrarEmojis, setMostrarEmojis] = useState(false);
  const [interagiu, setInteragiu] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [chatAberto, setChatAberto] = useState(false); // NOVO ESTADO
  const navigate = useNavigate();
  const audioRef = useRef(null);
  const chatRef = useRef(null);

  const documentosFiltrados = documentos.filter((d) => d.tipo === categoriaAtiva);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUsuario(user);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const chatRef = ref(database, "biblioteca_chat");
    onValue(chatRef, (snapshot) => {
      const dados = snapshot.val();
      if (dados) {
        const lista = Object.entries(dados)
          .map(([id, msg]) => ({
            id,
            ...msg,
          }))
          .sort((a, b) => a.timestamp - b.timestamp);

        setMensagens((prev) => {
          if (interagiu && prev.length < lista.length && audioRef.current) {
            const lastMsg = lista[lista.length - 1];
            if (lastMsg.autor !== (usuario?.displayName || usuario?.email)) {
              audioRef.current.play().catch((err) => console.warn("⚠️ Som bloqueado:", err.message));
            }
          }
          return lista;
        });
      }
    });
  }, [usuario, interagiu]);

  useEffect(() => {
    const handlePrimeiraInteracao = () => setInteragiu(true);
    window.addEventListener("click", handlePrimeiraInteracao);
    return () => window.removeEventListener("click", handlePrimeiraInteracao);
  }, []);

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [mensagens]);

  const enviarMensagem = async () => {
    if (novaMensagem.trim() && usuario) {
      setIsLoading(true);
      try {
        const novaRef = ref(database, "biblioteca_chat");
        await push(novaRef, {
          texto: novaMensagem.trim(),
          timestamp: Date.now(),
          autor: usuario.displayName || usuario.email || "Anônimo",
          likes: 0,
        });
        setNovaMensagem("");
        setMostrarEmojis(false);
      } catch (error) {
        console.error("Erro ao enviar mensagem:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const curtirMensagem = async (id, likes = 0) => {
    try {
      const msgRef = ref(database, `biblioteca_chat/${id}/likes`);
      await set(msgRef, likes + 1);
    } catch (error) {
      console.error("Erro ao curtir mensagem:", error);
    }
  };

  const voltarParaLista = () => setDocSelecionado(null);

  const adicionarEmoji = (emoji) => {
    setNovaMensagem(prev => prev + emoji);
    setMostrarEmojis(false);
  };

  if (docSelecionado) {
    return (
      <motion.div 
        style={styles.containerFull}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.header 
          style={styles.headerDocumento}
          initial={{ y: -50 }}
          animate={{ y: 0 }}
          transition={{ type: "spring", stiffness: 100 }}
        >
          <motion.button 
            onClick={voltarParaLista} 
            style={styles.btnVoltar}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            aria-label="Voltar para lista de documentos"
          >
            ← Biblioteca
          </motion.button>
          <h1 style={styles.tituloDocumento}>{docSelecionado.titulo}</h1>
          <motion.button
            onClick={() => navigate("/")}
            style={styles.btnHome}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            aria-label="Ir para página inicial"
          >
            🏠
          </motion.button>
        </motion.header>
        <motion.iframe
          title={docSelecionado.titulo}
          src={`https://drive.google.com/file/d/${docSelecionado.driveId}/preview`}
          style={styles.iframeDocumento}
          allow="autoplay"
          loading="lazy"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        />
      </motion.div>
    );
  }

  return (
    <motion.div 
      style={styles.container}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <motion.header 
        style={styles.header}
        initial={{ y: -50 }}
        animate={{ y: 0 }}
        transition={{ type: "spring", stiffness: 100 }}
      >
        <div style={styles.headerContent}>
          <h1 style={styles.titulo}>📚 Biblioteca Digital</h1>
          <p style={styles.subtitulo}>Conhecimento ao teu alcance</p>
        </div>
        
        <motion.nav 
          style={styles.navCategorias} 
          role="tablist" 
          aria-label="Categorias de documentos"
        >
          {categorias.map((cat, index) => (
            <motion.button
              key={cat.nome}
              onClick={() => setCategoriaAtiva(cat.nome)}
              style={{
                ...styles.btnCategoria,
                ...(categoriaAtiva === cat.nome ? { 
                  backgroundColor: cat.cor,
                  color: "white",
                  transform: "scale(1.05)"
                } : {})
              }}
              role="tab"
              aria-selected={categoriaAtiva === cat.nome}
              tabIndex={categoriaAtiva === cat.nome ? 0 : -1}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <span style={styles.categoriaIcone}>{cat.icone}</span>
              {cat.nome}
            </motion.button>
          ))}
        </motion.nav>
      </motion.header>

      <main style={styles.main}>
        <motion.section 
          style={styles.lista}
          aria-label="Lista de documentos"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.3 }}
        >
          <div style={styles.listaHeader}>
            <h2 style={styles.listaTitulo}>
              {categorias.find(c => c.nome === categoriaAtiva)?.icone} {categoriaAtiva}
            </h2>
            <span style={styles.contador}>{documentosFiltrados.length} documentos</span>
          </div>
          
          <div style={styles.listaContainer}>
            {documentosFiltrados.length === 0 ? (
              <motion.div 
                style={styles.semDocs}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
              >
                <span style={styles.semDocsIcone}>📭</span>
                <p style={styles.semDocsText}>Nenhum documento nesta categoria.</p>
              </motion.div>
            ) : (
              <AnimatePresence>
                {documentosFiltrados.map((doc, index) => (
                  <motion.button
                    key={doc.id}
                    onClick={() => setDocSelecionado(doc)}
                    style={styles.btnDocumento}
                    title={`Abrir ${doc.titulo}`}
                    aria-label={`Abrir documento ${doc.titulo}`}
                    whileHover={{ 
                      scale: 1.02,
                      boxShadow: "0 8px 25px rgba(0,0,0,0.15)"
                    }}
                    whileTap={{ scale: 0.98 }}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.05 }}
                    exit={{ opacity: 0, y: -20 }}
                  >
                    <span style={styles.documentoIcone}>{doc.icone}</span>
                    <div style={styles.documentoInfo}>
                      <h3 style={styles.documentoTitulo}>{doc.titulo}</h3>
                      <span style={styles.documentoTipo}>{doc.tipo}</span>
                    </div>
                    <span style={styles.documentoArrow}>→</span>
                  </motion.button>
                ))}
              </AnimatePresence>
            )}
          </div>
        </motion.section>

        {/* Botão flutuante para abrir o chat */}
        <button
          style={styles.fabChat}
          aria-label="Abrir chat dos estudantes"
          onClick={() => setChatAberto(true)}
        >
          💬
        </button>

        {/* Modal/Painel do chat */}
        {chatAberto && (
          <>
            {/* Overlay com blur */}
            <motion.div
              style={styles.chatOverlay}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              onClick={() => setChatAberto(false)}
            />
            <motion.div
              style={styles.chatModal}
              initial={{ opacity: 0, y: 50, scale: 0.98 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 50, scale: 0.98 }}
              transition={{ duration: 0.3 }}
            >
              <motion.header style={styles.chatHeader}>
                <h3 style={styles.chatTitulo}>💬 Chat dos Estudantes</h3>
                <button
                  style={styles.btnFecharChat}
                  aria-label="Fechar chat"
                  onClick={() => setChatAberto(false)}
                >
                  ✖
                </button>
              </motion.header>
              <div 
                ref={chatRef}
                style={styles.chatMensagens} 
                role="log" 
                aria-live="polite" 
                tabIndex="0"
              >
                {mensagens.length === 0 ? (
                  <motion.div 
                    style={styles.semMsgs}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                  >
                    <span style={styles.semMsgsIcone}>💭</span>
                    <p style={styles.semMsgsText}>Seja o primeiro a comentar!</p>
                  </motion.div>
                ) : (
                  <AnimatePresence>
                    {mensagens.map((msg, index) => {
                      const isUsuario = msg.autor === (usuario?.displayName || usuario?.email);
                      return (
                        <motion.article
                          key={msg.id}
                          style={{
                            ...styles.mensagem,
                            alignSelf: isUsuario ? "flex-end" : "flex-start",
                            backgroundColor: isUsuario ? "#dcf8c6" : "#fff",
                            borderTopLeftRadius: isUsuario ? 14 : 4,
                            borderTopRightRadius: isUsuario ? 4 : 14,
                          }}
                          initial={{ opacity: 0, y: 20, scale: 0.95 }}
                          animate={{ opacity: 1, y: 0, scale: 1 }}
                          transition={{ delay: index * 0.1 }}
                          whileHover={{ scale: 1.02 }}
                        >
                          <div style={styles.msgHeader}>
                            <strong style={styles.msgAutor}>
                              {isUsuario ? "Você" : msg.autor || "Anônimo"}
                            </strong>
                            <time
                              style={styles.msgTimestamp}
                              dateTime={new Date(msg.timestamp).toISOString()}
                              title={new Date(msg.timestamp).toLocaleString()}
                            >
                              {new Date(msg.timestamp).toLocaleString("pt-MZ")}
                            </time>
                          </div>
                          <p style={styles.msgTexto}>{msg.texto}</p>
                          <motion.button
                            style={styles.btnCurtir}
                            onClick={() => curtirMensagem(msg.id, msg.likes || 0)}
                            aria-label={`Curtir mensagem de ${msg.autor || "Anônimo"}`}
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                          >
                            ❤️ {msg.likes || 0}
                          </motion.button>
                        </motion.article>
                      );
                    })}
                  </AnimatePresence>
                )}
              </div>
              <motion.form
                style={styles.formChat}
                onSubmit={(e) => {
                  e.preventDefault();
                  enviarMensagem();
                }}
                aria-label="Enviar mensagem no chat"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
              >
                <div style={styles.inputContainer}>
                  <motion.button
                    type="button"
                    onClick={() => setMostrarEmojis(!mostrarEmojis)}
                    style={styles.btnEmoji}
                    aria-label="Mostrar emojis"
                    title="Adicionar emojis"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                  >
                    😊
                  </motion.button>
                  <AnimatePresence>
                    {mostrarEmojis && (
                      <motion.div
                        style={styles.painelEmojis}
                        role="list"
                        aria-label="Seleção de emojis"
                        initial={{ opacity: 0, scale: 0.8, y: 10 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.8, y: 10 }}
                        transition={{ type: "spring", stiffness: 300 }}
                      >
                        {emojis.map((emoji) => (
                          <motion.button
                            key={emoji}
                            type="button"
                            onClick={() => adicionarEmoji(emoji)}
                            style={styles.emojiItem}
                            aria-label={`Adicionar emoji ${emoji}`}
                            whileHover={{ scale: 1.2 }}
                            whileTap={{ scale: 0.9 }}
                          >
                            {emoji}
                          </motion.button>
                        ))}
                      </motion.div>
                    )}
                  </AnimatePresence>
                  <input
                    type="text"
                    placeholder={usuario ? "Escreve tua mensagem..." : "Faça login para enviar mensagens"}
                    value={novaMensagem}
                    onChange={(e) => setNovaMensagem(e.target.value)}
                    style={styles.inputMensagem}
                    disabled={!usuario || isLoading}
                    aria-disabled={!usuario || isLoading}
                    aria-required="true"
                  />
                  <motion.button
                    type="submit"
                    style={{
                      ...styles.btnEnviar,
                      ...(novaMensagem.trim() === "" || !usuario || isLoading
                        ? styles.btnEnviarDisabled
                        : {}),
                    }}
                    disabled={novaMensagem.trim() === "" || !usuario || isLoading}
                    aria-disabled={novaMensagem.trim() === "" || !usuario || isLoading}
                    whileHover={novaMensagem.trim() !== "" && usuario && !isLoading ? { scale: 1.05 } : {}}
                    whileTap={novaMensagem.trim() !== "" && usuario && !isLoading ? { scale: 0.95 } : {}}
                  >
                    {isLoading ? "⏳" : "Enviar"}
                  </motion.button>
                </div>
              </motion.form>
            </motion.div>
          </>
        )}
      </main>
      {/* Áudio para nova mensagem */}
      <audio ref={audioRef} src="/assets/msg.wav" preload="auto" />
    </motion.div>
  );
}

const styles = {
  // === CONTAINER PRINCIPAL ===
  container: {
    fontFamily: "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    color: "#2c2c2c",
    backgroundColor: "#f8f9fa",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    transition: "all 0.3s ease",
    overflowX: "hidden",
    padding: 0,
  },

  // === HEADER ===
  header: {
    background: "linear-gradient(135deg, #a82525 0%, #7f1c1c 100%)",
    color: "#fff",
    padding: "clamp(20px, 4vw, 30px) clamp(16px, 3vw, 24px)",
    textAlign: "center",
    boxShadow: "0 4px 20px rgba(168, 37, 37, 0.3)",
    position: "relative",
    overflow: "hidden",
  },

  headerContent: {
    marginBottom: "clamp(15px, 3vw, 20px)",
  },

  titulo: {
    margin: 0,
    fontSize: "clamp(1.8rem, 4vw, 2.2rem)",
    fontWeight: "900",
    textShadow: "0 2px 4px rgba(0,0,0,0.2)",
    letterSpacing: "0.5px",
  },

  subtitulo: {
    fontSize: "clamp(0.9rem, 2vw, 1rem)",
    color: "#fff",
    opacity: 0.9,
    marginTop: "8px",
    fontWeight: "400",
  },

  navCategorias: {
    display: "flex",
    justifyContent: "center",
    gap: "clamp(10px, 2vw, 16px)",
    flexWrap: "wrap",
    userSelect: "none",
  },

  btnCategoria: {
    backgroundColor: "rgba(255,255,255,0.9)",
    border: "2px solid rgba(255,255,255,0.3)",
    borderRadius: "clamp(20px, 4vw, 25px)",
    padding: "clamp(10px, 2vw, 14px) clamp(16px, 3vw, 24px)",
    fontWeight: "700",
    fontSize: "clamp(0.9rem, 2vw, 1rem)",
    color: "#a82525",
    cursor: "pointer",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    userSelect: "none",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
    backdropFilter: "blur(10px)",
  },

  categoriaIcone: {
    fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
  },

  // === MAIN CONTENT ===
  main: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    padding: "clamp(20px, 4vw, 30px) clamp(16px, 3vw, 24px)",
    gap: "clamp(24px, 5vw, 32px)",
    overflowX: "hidden",
    width: "100%", // garantir 100% da largura
    maxWidth: "100vw", // evitar overflow
  },

  // === LISTA DE DOCUMENTOS ===
  lista: {
    display: "flex",
    flexDirection: "column",
    gap: "clamp(16px, 3vw, 20px)",
    maxHeight: "none", // remover limite de altura
    overflowY: "auto",
    paddingRight: "8px",
    minWidth: 0,
    width: "95%", // ocupar toda a largura
    maxWidth: "100%", // ocupar toda a largura
  },

  listaHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "clamp(12px, 2vw, 16px)",
    padding: "0 4px",
  },

  listaTitulo: {
    fontSize: "clamp(1.2rem, 3vw, 1.4rem)",
    fontWeight: "900",
    color: "#a82525",
    userSelect: "none",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  contador: {
    fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
    color: "#666",
    fontStyle: "italic",
    backgroundColor: "rgba(168, 37, 37, 0.1)",
    padding: "4px 8px",
    borderRadius: "12px",
  },

  listaContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "clamp(12px, 2vw, 16px)",
  },

  semDocs: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "clamp(40px, 8vw, 60px) 0",
    color: "#666",
    fontStyle: "italic",
  },

  semDocsIcone: {
    fontSize: "clamp(3rem, 8vw, 4rem)",
    marginBottom: "clamp(10px, 2vw, 16px)",
    opacity: 0.6,
  },

  semDocsText: {
    fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
    textAlign: "center",
  },

  btnDocumento: {
    backgroundColor: "#fff",
    border: "2px solid #e0e0e0",
    borderRadius: "clamp(12px, 2.5vw, 16px)",
    padding: "clamp(16px, 3vw, 20px)",
    fontWeight: "600",
    fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
    color: "#333",
    cursor: "pointer",
    userSelect: "none",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    display: "flex",
    alignItems: "center",
    gap: "clamp(12px, 2vw, 16px)",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    position: "relative",
    overflow: "hidden",
  },

  documentoIcone: {
    fontSize: "clamp(1.5rem, 4vw, 2rem)",
    flexShrink: 0,
  },

  documentoInfo: {
    flexGrow: 1,
    minWidth: 0,
  },

  documentoTitulo: {
    fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
    fontWeight: "700",
    color: "#333",
    marginBottom: "4px",
    lineHeight: 1.3,
    wordBreak: "break-word",
  },

  documentoTipo: {
    fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
    color: "#666",
    fontStyle: "italic",
    backgroundColor: "rgba(168, 37, 37, 0.1)",
    padding: "2px 6px",
    borderRadius: "8px",
    display: "inline-block",
  },

  documentoArrow: {
    fontSize: "clamp(1.2rem, 3vw, 1.5rem)",
    color: "#a82525",
    marginLeft: "auto",
    flexShrink: 0,
    transition: "transform 0.3s ease",
  },

  // === CHAT CONTAINER ===
  chatContainer: {
    flexGrow: 1,
    backgroundColor: "#fff",
    borderRadius: "clamp(16px, 3vw, 20px)",
    boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
    padding: "clamp(20px, 4vw, 24px)",
    display: "flex",
    flexDirection: "column",
    minHeight: "clamp(400px, 60vh, 500px)",
    overflowX: "hidden",
    border: "1px solid rgba(0,0,0,0.05)",
  },

  chatHeader: {
    marginBottom: "clamp(16px, 3vw, 20px)",
    paddingBottom: "clamp(12px, 2vw, 16px)",
    borderBottom: "2px solid #f0f0f0",
  },

  chatTitulo: {
    fontSize: "clamp(1.3rem, 3vw, 1.5rem)",
    fontWeight: "900",
    color: "#a82525",
    userSelect: "none",
    margin: 0,
  },

  chatSubtitle: {
    fontSize: "clamp(0.9rem, 2vw, 1rem)",
    color: "#666",
    fontStyle: "italic",
    marginTop: "4px",
  },

  chatMensagens: {
    flexGrow: 1,
    overflowY: "auto",
    paddingRight: "8px",
    maxHeight: "clamp(300px, 50vh, 400px)",
    minHeight: "clamp(200px, 30vh, 250px)",
    userSelect: "text",
    display: "flex",
    flexDirection: "column",
    gap: "clamp(12px, 2vw, 16px)",
  },

  semMsgs: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "clamp(40px, 8vw, 60px) 0",
    color: "#bbb",
    fontStyle: "italic",
    flexGrow: 1,
  },

  semMsgsIcone: {
    fontSize: "clamp(3rem, 8vw, 4rem)",
    marginBottom: "clamp(10px, 2vw, 16px)",
    opacity: 0.6,
  },

  semMsgsText: {
    fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
    textAlign: "center",
  },

  mensagem: {
    backgroundColor: "#f8f9fa",
    padding: "clamp(12px, 2.5vw, 16px)",
    borderRadius: "clamp(12px, 2.5vw, 16px)",
    marginBottom: "clamp(8px, 1.5vw, 12px)",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    wordBreak: "break-word",
    maxWidth: "85%",
    position: "relative",
  },

  msgHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "clamp(6px, 1.5vw, 8px)",
  },

  msgAutor: {
    color: "#a82525",
    fontWeight: "700",
    fontSize: "clamp(0.9rem, 2vw, 1rem)",
  },

  msgTimestamp: {
    color: "#999",
    fontSize: "clamp(0.7rem, 1.8vw, 0.8rem)",
    fontStyle: "italic",
  },

  msgTexto: {
    fontSize: "clamp(0.95rem, 2.2vw, 1rem)",
    lineHeight: 1.5,
    margin: 0,
  },

  btnCurtir: {
    marginTop: "clamp(6px, 1.5vw, 8px)",
    background: "none",
    border: "none",
    color: "#a82525",
    fontWeight: "600",
    cursor: "pointer",
    userSelect: "none",
    fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
    padding: "4px 8px",
    borderRadius: "8px",
    transition: "all 0.2s ease",
  },

  // === FORM CHAT ===
  formChat: {
    borderTop: "2px solid #f0f0f0",
    paddingTop: "clamp(16px, 3vw, 20px)",
    width: "100%",
    boxSizing: "border-box",
  },

  inputContainer: {
    display: "flex",
    alignItems: "center",
    gap: "clamp(8px, 2vw, 12px)",
    position: "relative",
  },

  btnEmoji: {
    backgroundColor: "#fff",
    border: "2px solid #e0e0e0",
    borderRadius: "clamp(12px, 2.5vw, 16px)",
    width: "clamp(44px, 8vw, 48px)",
    height: "clamp(44px, 8vw, 48px)",
    fontSize: "clamp(1.2rem, 3vw, 1.4rem)",
    color: "#666",
    cursor: "pointer",
    userSelect: "none",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },

  painelEmojis: {
    position: "absolute",
    bottom: "clamp(60px, 12vw, 72px)",
    left: "0",
    backgroundColor: "#fff",
    borderRadius: "clamp(12px, 2.5vw, 16px)",
    padding: "clamp(12px, 2.5vw, 16px)",
    display: "flex",
    flexWrap: "wrap",
    gap: "clamp(6px, 1.5vw, 8px)",
    boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
    userSelect: "none",
    zIndex: 100,
    border: "1px solid rgba(0,0,0,0.1)",
    maxWidth: "clamp(200px, 50vw, 300px)",
  },

  emojiItem: {
    backgroundColor: "transparent",
    border: "none",
    fontSize: "clamp(1.2rem, 3vw, 1.5rem)",
    cursor: "pointer",
    userSelect: "none",
    padding: "clamp(4px, 1vw, 6px)",
    borderRadius: "6px",
    transition: "background-color 0.2s ease",
  },

  inputMensagem: {
    flexGrow: 1,
    padding: "clamp(12px, 2.5vw, 16px)",
    fontSize: "clamp(0.95rem, 2.2vw, 1rem)",
    borderRadius: "clamp(12px, 2.5vw, 16px)",
    border: "2px solid #e0e0e0",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    minWidth: 0,
    outline: "none",
  },

  btnEnviar: {
    padding: "clamp(12px, 2.5vw, 16px) clamp(20px, 4vw, 24px)",
    backgroundColor: "#a82525",
    color: "#fff",
    border: "none",
    borderRadius: "clamp(12px, 2.5vw, 16px)",
    cursor: "pointer",
    fontWeight: "700",
    fontSize: "clamp(0.9rem, 2.2vw, 1rem)",
    userSelect: "none",
    boxShadow: "0 4px 16px rgba(168, 37, 37, 0.3)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    flexShrink: 0,
  },

  btnEnviarDisabled: {
    backgroundColor: "#ccc",
    cursor: "not-allowed",
    boxShadow: "none",
  },

  // === TELA DOCUMENTO ===
  containerFull: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
    width: "100vw", // ocupar toda a largura
    maxWidth: "100vw",
  },

  headerDocumento: {
    display: "flex",
    alignItems: "center",
    gap: "clamp(16px, 3vw, 20px)",
    padding: "clamp(16px, 3vw, 20px) clamp(20px, 4vw, 24px)",
    backgroundColor: "#a82525",
    color: "#fff",
    userSelect: "none",
    boxShadow: "0 4px 20px rgba(168, 37, 37, 0.3)",
  },

  btnVoltar: {
    backgroundColor: "transparent",
    border: "none",
    color: "#fff",
    fontSize: "clamp(1.2rem, 3vw, 1.4rem)",
    cursor: "pointer",
    fontWeight: "700",
    userSelect: "none",
    transition: "all 0.3s ease",
    padding: "8px 12px",
    borderRadius: "8px",
  },

  btnHome: {
    marginLeft: "auto",
    backgroundColor: "transparent",
    border: "none",
    color: "#fff",
    fontSize: "clamp(1.4rem, 3.5vw, 1.6rem)",
    cursor: "pointer",
    fontWeight: "900",
    userSelect: "none",
    transition: "all 0.3s ease",
    padding: "8px 12px",
    borderRadius: "8px",
  },

  tituloDocumento: {
    fontSize: "clamp(1.3rem, 3vw, 1.6rem)",
    fontWeight: "700",
    flexGrow: 1,
    textAlign: "center",
    textShadow: "0 1px 3px rgba(0,0,0,0.2)",
    lineHeight: 1.3,
  },

  iframeDocumento: {
    flexGrow: 1,
    border: "none",
    width: "100%",
  },

  // === MEDIA QUERIES ===
  "@media (min-width: 768px)": {
    container: {
      flexDirection: "row",
      padding: 0,
      backgroundColor: "#f8f9fa",
    },

    header: {
      display: "none",
    },

    main: {
      flexDirection: "row",
      padding: "clamp(30px, 5vw, 40px)",
      gap: "clamp(40px, 6vw, 48px)",
      height: "100vh",
    },

    lista: {
      flexBasis: "clamp(350px, 40vw, 420px)",
      flexShrink: 0,
      maxHeight: "calc(100vh - clamp(60px, 10vw, 80px))",
      overflowY: "auto",
    },

    btnCategoria: {
      fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
    },

    chatContainer: {
      flexGrow: 1,
      maxHeight: "calc(100vh - clamp(60px, 10vw, 80px))",
      display: "flex",
      flexDirection: "column",
      minHeight: "auto",
    },

    chatMensagens: {
      maxHeight: "clamp(400px, 60vh, 500px)",
    },

    formChat: {
      borderTop: "2px solid #f0f0f0",
      paddingTop: "clamp(20px, 3vw, 24px)",
      gap: "clamp(12px, 2vw, 16px)",
    },

    btnEnviar: {
      fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
    },
  },

  "@media (max-width: 480px)": {
    main: {
      padding: "clamp(16px, 3vw, 20px)",
      gap: "clamp(20px, 4vw, 24px)",
    },

    lista: {
      maxHeight: "clamp(300px, 50vh, 400px)",
    },

    chatContainer: {
      minHeight: "clamp(350px, 55vh, 450px)",
    },

    chatMensagens: {
      maxHeight: "clamp(250px, 45vh, 350px)",
    },

    btnDocumento: {
      padding: "clamp(14px, 2.5vw, 16px)",
    },

    documentoTitulo: {
      fontSize: "clamp(0.95rem, 2.2vw, 1rem)",
    },
  },
  fabChat: {
    position: "fixed",
    right: 20,
    bottom: 24,
    zIndex: 1000,
    background: "#a82525",
    color: "#fff",
    border: "none",
    borderRadius: "50%",
    width: 56,
    height: 56,
    fontSize: 28,
    boxShadow: "0 4px 16px rgba(168, 37, 37, 0.3)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background 0.2s, box-shadow 0.2s",
  },
  chatOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(30, 30, 30, 0.25)",
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",
    zIndex: 1099,
    transition: "all 0.2s",
  },
  chatModal: {
    position: "fixed",
    right: 24, // alinhado ao botão flutuante
    bottom: 90, // logo acima do botão
    width: "clamp(320px, 95vw, 400px)",
    maxHeight: "clamp(400px, 80vh, 600px)",
    background: "rgba(255,255,255,0.95)",
    borderRadius: 22,
    boxShadow: "0 12px 48px 0 rgba(0,0,0,0.25)",
    zIndex: 1100,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    border: "1.5px solid #e0e0e0",
    padding: "0 0 8px 0",
    animation: "modalPop 0.3s cubic-bezier(.4,2,.6,1)",
    transform: "none", // remover centralização
  },
  btnFecharChat: {
    background: "none",
    border: "none",
    color: "#a82525",
    fontSize: 22,
    cursor: "pointer",
    marginLeft: "auto",
    padding: 8,
    borderRadius: 8,
    transition: "background 0.2s",
  },
};

